import { Link } from '@tanstack/react-router';
import { cn } from '@/shared/lib/cn';
import type { LoginSearch } from './loginPrefill';
import { AuthPageHeader } from './AuthPageHeader';
import { authBackLinkClass } from './authLinkStyles';

const MAIN =
  'rounded-pill bg-forest hover:bg-forest-deep flex h-[54px] w-full items-center justify-center text-base font-bold text-white';

/**
 * Eine Anmeldefläche ohne Formular (Board A, „alle Schritte“): gesendet, Link ungültig, schon
 * aktiv. Ein Satz in einer Karte, ein Hauptweg, darunter zurück zur Anmeldung.
 */
export function AuthStatusPage({
  eyebrow,
  title,
  text,
  tone = 'note',
  main,
  loginSearch,
}: {
  eyebrow: string;
  title: string;
  text: string;
  tone?: 'note' | 'error';
  main: { label: string; to: '/login' | '/forgot-password' };
  loginSearch?: LoginSearch;
}) {
  return (
    <>
      <AuthPageHeader eyebrow={eyebrow} title={title} />
      <p
        role={tone === 'error' ? 'alert' : 'status'}
        className={cn(
          'rounded-tile px-4 py-3.5 text-sm leading-relaxed',
          tone === 'error'
            ? 'bg-sealwax-tint text-sealwax font-semibold'
            : 'border-hairline border bg-white',
        )}
      >
        {text}
      </p>
      <Link
        to={main.to}
        search={main.to === '/login' ? (loginSearch ?? {}) : undefined}
        className={MAIN}
      >
        {main.label}
      </Link>
      {main.to !== '/login' && (
        <Link to="/login" search={loginSearch ?? {}} className={`${authBackLinkClass} self-center`}>
          Zurück zur Anmeldung
        </Link>
      )}
    </>
  );
}
